var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout-inner layout-404"},[_c('div',{staticClass:"content-holder w-100"},[_c('header',{staticClass:"content-header"},[_c('div',{staticClass:"container-1120 header-size"},[_c('h1',[_vm._v("404 Page Not Found")])])])])])
}]

export { render, staticRenderFns }